import { Field } from 'formik';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';


const TextareaField = ({ label, name }) => {
	return (
		<Row className='my-3'>
			<Card.Title>{label}</Card.Title>
			<Col md={12}>
				<Field name={name} as='textarea' className='form-control' />
			</Col>
		</Row>
	);
};

export default TextareaField;